import { render } from "./Quotes.vue?vue&type=template&id=4a127e6c&ts=true"
import script from "./Quotes.vue?vue&type=script&lang=ts"
export * from "./Quotes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__